module.exports = __webpack_public_path__ + "static/media/rebirth_sample_10.dd79ca42.jpg";